var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-cols",class:{
            'card-cols_mobile': _vm.$vuetify.breakpoint.smAndDown
        }},[_c('div',{staticClass:"card-cols__col"},[_vm._t("left")],2),_c('div',{staticClass:"card-cols__vline"}),_c('div',{staticClass:"card-cols__col"},[_vm._t("right")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }